<template>
  <h1>Right menu</h1>
</template>

<script>
export default {
  name: 'Account_dashboard'
}
</script>
